
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {

  document.title = `Kafka & I by Can Xue | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `Kafka & I collects Can Xue’s reflections on the enduring cult figure Franz Kafka. Turning to the questions and contradictions posed by his female characters, the volume comprises a series of potent essays exploring Kafka’s mediation of worlds spiritual and mundane, as an important influence on Can Xue, and a prerogative for contemporary readers and writers writ large.`);


  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-Three/CanXue_06_Mockup1.webp', '../../Series-Three/CanXue_06_Mockup2.webp', '../../Series-Three/CanXue_06_Mockup3.webp']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>Kafka & I</h1>
            <div className='productAuthor'>Can Xue</div>
            <div className='productTranslator'>Translated by Deanna Ren</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798989378074'} />
            <div className='productPrice'>$14.99 USD</div>
          </div>


          <div className='productDescription'><em>Kafka & I</em> collects Can Xue’s reflections on the enduring cult figure Franz Kafka. Turning to the questions and contradictions posed by his female characters, the volume comprises a series of potent essays exploring Kafka’s mediation of worlds spiritual and mundane, as an important influence on Can Xue, and a prerogative for contemporary readers and writers writ large.
          </div>
          <div className='productDescription'>
            <p>
              <strong>Can Xue</strong> is the pen name of the much lauded avant-garde writer, Deng Xiaohua, is the author of novels, short stories and works of criticism and philosophy that constitute an investigative literature of the soul. Her writing is characterized by the discerning eye of a reader, one in pursuit of poetic belonging. With an interplay between Chinese and western influences, and a distinct allegorical style, Can Xue’s work has been a longtime favorite for the Nobel Prize in Literature.
            </p>
            <p>
              <strong>Deanna Ren</strong> is a writer and translator working with an emphasis on decolonial translation theory and world literature. Interested in connections between music, art, history and everyday life, she regularly translates authors like Lu Xun and Can Xue. Ren graduated from Washington University in St. Louis with an MA in East Asian languages and cultures.
            </p>
            <p><em>Back cover photo: Xiao Quan</em></p>
          </div>
          <div className='productMetadata'>
            <div>Series III, No. 6</div>
            <div>Summer 2025</div>
            <div>ISBN 979–8–989378–07–4</div>
            <div>4.125 x 2.75 inches</div>
            <div>112 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)
}